import { createFileRoute } from "@tanstack/react-router";

import Categories from "@/containers/Categories";

export const Route = createFileRoute("/_app/(taxonomy)/categories")({
  component: () => <Categories />,
});
